export enum ChargerInstallationPermit {
	YES = 'YES',
	NO = 'NO',
	UNKNOWN = 'UNKNOWN',
}
